
import AutoTips from '@/components/AutoTips/index.vue';

export default {
  components: {
    AutoTips: AutoTips
  },

  props: {
    title: {
      type: String
    },
    desc: {
      type: String
    }
  }
};